export { filterNomeInput } from "@/lib/nomePessoa";
import { limiteAtendimentoNumero, type ModoAtendimento } from "@/lib/atendimentoMode";

/** Máscara (00) 9 9999-9999 */
export function formatWhatsappMask(value: string): string {
  const d = value.replace(/\D/g, "").slice(0, 11);
  if (d.length === 0) return "";
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 3) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2, 3)} ${d.slice(3)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 3)} ${d.slice(3, 7)}-${d.slice(7)}`;
}

export function whatsappDigits(value: string): string {
  return value.replace(/\D/g, "");
}

/** Somente dígitos enquanto digita. */
export function filterMesaInput(value: string, modo: ModoAtendimento = "mesa"): string {
  return value.replace(/\D/g, "").slice(0, limiteAtendimentoNumero(modo));
}

/** Remove zeros à esquerda; vazio se inválido. */
export function normalizeMesaDigits(value: string, modo: ModoAtendimento = "mesa"): string {
  const digits = filterMesaInput(value, modo);
  if (!digits) return "";
  if (modo !== "mesa") return digits;
  const n = parseInt(digits, 10);
  return Number.isFinite(n) && n > 0 ? String(n) : "";
}

/**
 * Mesa vinda de `/cardapio/:mesa`.
 * Aceita só inteiros positivos em dígitos (ex.: "01" → "1").
 * Rejeita letras, sinal, zero e decimais ("abc", "-1", "0", "1.5").
 */
export function parseMesaFromUrlParam(raw: string | undefined | null, modo: ModoAtendimento = "mesa"): string {
  if (raw == null) return "";
  const s = String(raw).trim();
  if (!/^\d+$/.test(s)) return "";
  return normalizeMesaDigits(s, modo);
}
